// extracted by mini-css-extract-plugin
module.exports = {"root":"social_root__3n58D","outer":"social_outer__2T8p6","inner":"social_inner__2arJn","heading":"social_heading__3WFLB","icons":"social_icons__3VKf3"};